import { Typography } from "@aviary";

import * as styles from "./OAuthStepHeader.styles";

interface Props {
  title: string;
  description: string;
}

const OAuthStepHeader = ({ title, description }: Props) => {
  return (
    <div css={styles.main}>
      <Typography type="h2">{title}</Typography>
      <Typography>{description}</Typography>
    </div>
  );
};

export { OAuthStepHeader };
